import { Injectable } from '@angular/core';

import { MoneyService } from '@frontend/sports/common/core/feature/money';
import { interpolateDoubleBracesString } from '@frontend/sports/common/core/utils/string';
import { SyncUserSettingsService } from '@frontend/sports/user/feature';

import { ErrorMessageCurrencySymbolFormatService } from './error-message-currency-symbol-format.service';

@Injectable()
export class MinStakeMessageFormattingHelper {
    constructor(
        private userSettings: SyncUserSettingsService,
        private currencySymbolFormatService: ErrorMessageCurrencySymbolFormatService,
        private moneyService: MoneyService,
    ) {}

    formatMessage(message: string): string {
        const minStake = this.userSettings.configSettings.minimumStake;

        const formattedMessage = this.currencySymbolFormatService.updateCurrencyPlaceholders(message);
        const formattedMinStake = this.moneyService.transform(minStake);

        return interpolateDoubleBracesString(formattedMessage, { minStake: formattedMinStake });
    }
}
